import { useEffect } from "react";

type UseDeeplinkRedirectProps = {
  path: string;
  query?: Record<string, string>;
  beforeRedirect?: () => void | Promise<void>;
  onMount?: () => void | Promise<void>;
  onError?: (e: Error) => void | Promise<void>;
};

const useDeeplinkRedirect = ({
  path,
  query = {},
  beforeRedirect,
  onMount,
  onError,
}: UseDeeplinkRedirectProps) => {
  const userAgent = navigator.userAgent || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  useEffect(() => {
    const redirectToApp = async () => {
      try {
        await onMount?.();

        const fullPath = Object.values(query).length
          ? `${path}?${new URLSearchParams(query).toString()}`
          : path;
        const appUrl = `squaay://${fullPath}`;
        // const appUrl = `exp://localhost:8081/--/${fullPath}`;

        let fallbackUrl = "https://squaay.com";
        if (isAndroid && !isIOS)
          fallbackUrl =
            "https://play.google.com/store/apps/details?id=com.squaay.android";
        if (isIOS && !isAndroid)
          fallbackUrl = "https://apps.apple.com/app/squaay/id6740501959";

        if (!appUrl) {
          window.location.href = fallbackUrl;
          return;
        }

        await beforeRedirect?.();

        window.location.href = appUrl;

        setTimeout(() => (window.location.href = fallbackUrl), 2000);
      } catch (error) {
        if (onError) {
          await onError(error as Error);
        }
      }
    };

    redirectToApp();
  }, [beforeRedirect, isAndroid, isIOS, onError, onMount, path, query]);
};

export default useDeeplinkRedirect;
